export const APPLICATION_STATE = "ODYSSEY.APPLICATION.STATE"
export const USER_ACCESS_TOKEN = "ODYSSEY.USER.AUTHENTICATION"